module.exports = __webpack_public_path__ + "media/french_18th_century_salon.73484b53.wav";